import { useEffect } from 'react';
import { useUnmount } from 'usehooks-ts';

export const useElementAttribute = (
  attributes: Record<string, string>,
  targetElementQuery: string,
) => {
  useEffect(() => {
    const element = document?.querySelector(targetElementQuery);

    if (!attributes || !element) {
      return;
    }

    Object.keys(attributes).forEach((key) => {
      element.setAttribute(key, attributes[key]);
    });
  }, [attributes, targetElementQuery]);

  useUnmount(() => {
    const element = document?.querySelector(targetElementQuery);

    if (!attributes || !element) {
      return;
    }

    Object.keys(attributes).forEach((key) => {
      element.removeAttribute(key);
    });
  });
};
